import advancedFilters from './advancedFilters.json';
import agentBots from './agentBots.json';
import agentMgmt from './agentMgmt.json';
import attributesMgmt from './attributesMgmt.json';
import auditLogs from './auditLogs.json';
import automation from './automation.json';
import bulkActions from './bulkActions.json';
import campaign from './campaign.json';
import cannedMgmt from './cannedMgmt.json';
import chatlist from './chatlist.json';
import contact from './contact.json';
import contactFilters from './contactFilters.json';
import conversation from './conversation.json';
import csatMgmt from './csatMgmt.json';
import emoji from './emoji.json';
import generalSettings from './generalSettings.json';
import helpCenter from './helpCenter.json';
import inboxMgmt from './inboxMgmt.json';
import integrationApps from './integrationApps.json';
import integrations from './integrations.json';
import labelsMgmt from './labelsMgmt.json';
import login from './login.json';
import macros from './macros.json';
import report from './report.json';
import resetPassword from './resetPassword.json';
import search from './search.json';
import setNewPassword from './setNewPassword.json';
import settings from './settings.json';
import signup from './signup.json';
import teamsSettings from './teamsSettings.json';
import whatsappTemplates from './whatsappTemplates.json';
import sla from './sla.json';
import inbox from './inbox.json';
import general from './general.json';
import datePicker from './datePicker.json';
import knowledge from './knowledge.json';
import branches from './branches.json';
import appointments from './appointments.json';
import realEstate from './realEstate.json';
import coLiving from './coLiving.json';
import knowledgeImprovemnt from './knowledgeImprovement.json';
import scheduledMessages from './scheduledMessages.json';
import chatBotConfiguration from './chatBotConfiguration.json';
import subscription from './subscription.json';
import promoCode from './promoCode.json';
import sync from './sync.json';
import onboardingShell from './onboardingShell.json';
import creditUsage from './creditUsage.json';
import mfa from './mfa.json';
import onboardingGuide from './onboardingGuide.json';

export default {
  ...advancedFilters,
  ...agentBots,
  ...agentMgmt,
  ...attributesMgmt,
  ...auditLogs,
  ...automation,
  ...bulkActions,
  ...campaign,
  ...cannedMgmt,
  ...chatlist,
  ...contact,
  ...contactFilters,
  ...conversation,
  ...csatMgmt,
  ...emoji,
  ...generalSettings,
  ...helpCenter,
  ...inboxMgmt,
  ...integrationApps,
  ...integrations,
  ...labelsMgmt,
  ...login,
  ...macros,
  ...report,
  ...resetPassword,
  ...search,
  ...setNewPassword,
  ...settings,
  ...signup,
  ...sla,
  ...teamsSettings,
  ...whatsappTemplates,
  ...inbox,
  ...general,
  ...datePicker,
  ...knowledge,
  ...branches,
  ...appointments,
  ...realEstate,
  ...coLiving,
  ...knowledgeImprovemnt,
  ...scheduledMessages,
  ...chatBotConfiguration,
  ...subscription,
  ...promoCode,
  ...sync,
  ...onboardingShell,
  ...creditUsage,
  ...mfa,
  ...onboardingGuide,
};
